export const getAllAmberReports = (state) => state?.blog?.availableBlogs;

export const selectFeeds = (feeds) => {
  let feedsForSelect = [];

  if (feeds?.length > 0) {
    feeds.forEach((feed) => {
      feedsForSelect.push({ label: feed?.name, value: feed?.uuid });
    });
    feedsForSelect.sort((a, b) => a.label.localeCompare(b.label));

    return feedsForSelect;
  } else {
    return [];
  }
};

export const selectTags = (tags) => {
  let tagsForSelect = [];

  if (tags?.results?.length > 0) {
    tags.results.forEach((tag) => {
      tagsForSelect.push({ label: tag?.tag, value: tag?.tag });
    });
    tagsForSelect.sort((a, b) => a.label.localeCompare(b.label));

    return tagsForSelect;
  } else {
    return [];
  }
};
